import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import {
  PARCEIROS_ACCENT,
  PARCEIROS_BG,
  PARCEIROS_LOGIN_PATH,
  PARCEIROS_LOGO,
  ROCKET_SITE_URL,
} from './parceirosBrand'
import { ParceirosBackdrop } from './ParceirosBackdrop'
import './parceirosPublic.css'

type Props = {
  children: ReactNode
  rightSlot?: ReactNode
}

export function ParceirosBrandShell({ children, rightSlot }: Props) {
  return (
    <div className='parceiros-public relative min-h-screen text-white' style={{ background: PARCEIROS_BG }}>
      <ParceirosBackdrop />

      <header className='relative z-10 mx-auto flex w-full max-w-6xl items-center justify-between gap-4 px-6 py-5'>
        <a href={ROCKET_SITE_URL} className='flex items-center gap-2' target='_blank' rel='noreferrer'>
          <img src={PARCEIROS_LOGO} alt='RocketSearch' className='h-8 w-auto' />
        </a>
        <nav className='flex items-center gap-3 text-sm'>
          {rightSlot ?? (
            <Link
              to={PARCEIROS_LOGIN_PATH}
              className='rounded-full px-4 py-2 font-medium text-white active:scale-95'
              style={{ background: PARCEIROS_ACCENT }}
            >
              Login
            </Link>
          )}
        </nav>
      </header>

      <main className='relative z-10 mx-auto w-full max-w-6xl px-6 pb-16 pt-6'>{children}</main>
    </div>
  )
}
